<template>
  <div class="project-party-list">
    <div v-if="!parties || parties.length === 0" class="text-muted text-center py-3">
      <i class="fa fa-users fa-2x mb-2 d-block"></i>
      {{ $t('noPartiesAssigned') }}
    </div>
    <div v-else>
      <b-row
        v-for="(party, index) in parties"
        :key="party._id || `party-${index}`"
        class="party-row mb-2"
      >
        <b-col sm="12">
          <div class="d-flex align-items-center">
            <div class="party-info flex-grow-1">
              <router-link
                v-if="party.number"
                target="_blank"
                :to="{
                  name: 'PartyEditPage',
                  params: { partyNumber: party.number },
                }"
                class="mr-2"
              >
                #{{ party.number.toString().padStart(4, '0') }}
                <i class="fa fa-sm fa-external-link"></i>
              </router-link>
              {{ partyDisplayName(party) }}
              <div v-if="party.email" class="text-muted ml-2">
                <small
                  ><a :href="`mailto:${party.email}`">{{ party.email }}</a></small
                >
              </div>
            </div>
            <button
              class="btn btn-sm btn-danger ml-2"
              @click="removeParty(index)"
              :title="$t('remove')"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectPartyList',
  props: {
    parties: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    partyDisplayName(party) {
      const personName = [party.firstname, party.lastname]
        .filter(Boolean)
        .join(' ')
        .trim();
      const company = party.company?.trim() || '';

      if (company && personName) {
        return `${company} - ${personName}`;
      }
      if (personName) {
        return personName;
      }
      if (company) {
        return company;
      }
      return '-';
    },
    removeParty(index) {
      const updatedParties = this.parties.filter((_, i) => i !== index);
      this.$emit('update-parties', updatedParties);
    },
  },
};
</script>

<style scoped lang="scss">
.party-row {
  padding: 0.25rem 0;

  &:hover {
    background-color: #f8f9fa;
  }
}

.party-info {
  min-height: 32px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
